import Vue from 'vue'
import Router from 'vue-router'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _c80b8086 = () => interopDefault(import('../pages/account/index.vue' /* webpackChunkName: "pages/account/index" */))
const _5efb539a = () => interopDefault(import('../pages/c/index.vue' /* webpackChunkName: "pages/c/index" */))
const _3e6e757f = () => interopDefault(import('../pages/clusters/index.vue' /* webpackChunkName: "pages/clusters/index" */))
const _1ff329ae = () => interopDefault(import('../pages/design-system/index.vue' /* webpackChunkName: "pages/design-system/index" */))
const _6b9eb0bd = () => interopDefault(import('../pages/fail-whale.vue' /* webpackChunkName: "pages/fail-whale" */))
const _8cee3606 = () => interopDefault(import('../pages/prefs.vue' /* webpackChunkName: "pages/prefs" */))
const _3f259745 = () => interopDefault(import('../pages/auth/login.vue' /* webpackChunkName: "pages/auth/login" */))
const _1ac34c44 = () => interopDefault(import('../pages/auth/logout.vue' /* webpackChunkName: "pages/auth/logout" */))
const _02803859 = () => interopDefault(import('../pages/auth/setup.vue' /* webpackChunkName: "pages/auth/setup" */))
const _5a748566 = () => interopDefault(import('../pages/auth/verify.vue' /* webpackChunkName: "pages/auth/verify" */))
const _8c97b00a = () => interopDefault(import('../pages/design-system/form-controls.vue' /* webpackChunkName: "pages/design-system/form-controls" */))
const _4d55ed47 = () => interopDefault(import('../pages/rio/mesh.vue' /* webpackChunkName: "pages/rio/mesh" */))
const _67a70f18 = () => interopDefault(import('../pages/design-system/page-examples/create.vue' /* webpackChunkName: "pages/design-system/page-examples/create" */))
const _4f745826 = () => interopDefault(import('../pages/design-system/page-examples/detail.vue' /* webpackChunkName: "pages/design-system/page-examples/detail" */))
const _d6bfe28c = () => interopDefault(import('../pages/design-system/page-examples/list.vue' /* webpackChunkName: "pages/design-system/page-examples/list" */))
const _52fa306d = () => interopDefault(import('../pages/c/_cluster/index.vue' /* webpackChunkName: "pages/c/_cluster/index" */))
const _320406ea = () => interopDefault(import('../pages/c/_cluster/apps/index.vue' /* webpackChunkName: "pages/c/_cluster/apps/index" */))
const _d8f3e2c0 = () => interopDefault(import('../pages/c/_cluster/auth/index.vue' /* webpackChunkName: "pages/c/_cluster/auth/index" */))
const _49554afa = () => interopDefault(import('../pages/c/_cluster/backup/index.vue' /* webpackChunkName: "pages/c/_cluster/backup/index" */))
const _4aa43faa = () => interopDefault(import('../pages/c/_cluster/cis/index.vue' /* webpackChunkName: "pages/c/_cluster/cis/index" */))
const _0c2ddc6d = () => interopDefault(import('../pages/c/_cluster/ecm/index.vue' /* webpackChunkName: "pages/c/_cluster/ecm/index" */))
const _886d7c12 = () => interopDefault(import('../pages/c/_cluster/explorer/index.vue' /* webpackChunkName: "pages/c/_cluster/explorer/index" */))
const _3e0c5aac = () => interopDefault(import('../pages/c/_cluster/fleet/index.vue' /* webpackChunkName: "pages/c/_cluster/fleet/index" */))
const _999d7716 = () => interopDefault(import('../pages/c/_cluster/gatekeeper/index.vue' /* webpackChunkName: "pages/c/_cluster/gatekeeper/index" */))
const _aea8d3e4 = () => interopDefault(import('../pages/c/_cluster/istio/index.vue' /* webpackChunkName: "pages/c/_cluster/istio/index" */))
const _11d8a2bd = () => interopDefault(import('../pages/c/_cluster/logging/index.vue' /* webpackChunkName: "pages/c/_cluster/logging/index" */))
const _4d8c5092 = () => interopDefault(import('../pages/c/_cluster/longhorn/index.vue' /* webpackChunkName: "pages/c/_cluster/longhorn/index" */))
const _4a55f380 = () => interopDefault(import('../pages/c/_cluster/monitoring/index.vue' /* webpackChunkName: "pages/c/_cluster/monitoring/index" */))
const _fe6f1294 = () => interopDefault(import('../pages/c/_cluster/rio/index.vue' /* webpackChunkName: "pages/c/_cluster/rio/index" */))
const _1351612e = () => interopDefault(import('../pages/c/_cluster/virtual/index.vue' /* webpackChunkName: "pages/c/_cluster/virtual/index" */))
const _029d9a07 = () => interopDefault(import('../pages/console/_uid/serial.vue' /* webpackChunkName: "pages/console/_uid/serial" */))
const _5f155428 = () => interopDefault(import('../pages/console/_uid/vnc.vue' /* webpackChunkName: "pages/console/_uid/vnc" */))
const _500f4fed = () => interopDefault(import('../pages/c/_cluster/apps/charts.vue' /* webpackChunkName: "pages/c/_cluster/apps/charts" */))
const _2fc25733 = () => interopDefault(import('../pages/c/_cluster/apps/install.vue' /* webpackChunkName: "pages/c/_cluster/apps/install" */))
const _c7486a32 = () => interopDefault(import('../pages/c/_cluster/auth/config/index.vue' /* webpackChunkName: "pages/c/_cluster/auth/config/index" */))
const _5acf9708 = () => interopDefault(import('../pages/c/_cluster/explorer/HardwareResourceGauge.vue' /* webpackChunkName: "pages/c/_cluster/explorer/HardwareResourceGauge" */))
const _7865a948 = () => interopDefault(import('../pages/c/_cluster/gatekeeper/constraints/index.vue' /* webpackChunkName: "pages/c/_cluster/gatekeeper/constraints/index" */))
const _35a28178 = () => interopDefault(import('../pages/c/_cluster/rio/dashboard.vue' /* webpackChunkName: "pages/c/_cluster/rio/dashboard" */))
const _c1b4078e = () => interopDefault(import('../pages/c/_cluster/rio/mesh.vue' /* webpackChunkName: "pages/c/_cluster/rio/mesh" */))
const _27943ff2 = () => interopDefault(import('../pages/c/_cluster/rio/tap.vue' /* webpackChunkName: "pages/c/_cluster/rio/tap" */))
const _4548807a = () => interopDefault(import('../pages/c/_cluster/virtual/HardwareResourceGauge.vue' /* webpackChunkName: "pages/c/_cluster/virtual/HardwareResourceGauge" */))
const _bbcd205a = () => interopDefault(import('../pages/c/_cluster/virtual/Upgrade.vue' /* webpackChunkName: "pages/c/_cluster/virtual/Upgrade" */))
const _e34549e2 = () => interopDefault(import('../pages/c/_cluster/auth/config/_id.vue' /* webpackChunkName: "pages/c/_cluster/auth/config/_id" */))
const _c5a6f7b0 = () => interopDefault(import('../pages/c/_cluster/_product/index.vue' /* webpackChunkName: "pages/c/_cluster/_product/index" */))
const _523af6f4 = () => interopDefault(import('../pages/c/_cluster/_product/_resource/index.vue' /* webpackChunkName: "pages/c/_cluster/_product/_resource/index" */))
const _2d2256f8 = () => interopDefault(import('../pages/c/_cluster/_product/_resource/create.vue' /* webpackChunkName: "pages/c/_cluster/_product/_resource/create" */))
const _37981f24 = () => interopDefault(import('../pages/c/_cluster/_product/_resource/_id.vue' /* webpackChunkName: "pages/c/_cluster/_product/_resource/_id" */))
const _8d3c34fa = () => interopDefault(import('../pages/c/_cluster/_product/_resource/_namespace/_id.vue' /* webpackChunkName: "pages/c/_cluster/_product/_resource/_namespace/_id" */))
const _545eebc2 = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))

// TODO: remove in Nuxt 3
const emptyFn = () => {}
const originalPush = Router.prototype.push
Router.prototype.push = function push (location, onComplete = emptyFn, onAbort) {
  return originalPush.call(this, location, onComplete, onAbort)
}

Vue.use(Router)

export const routerOptions = {
  mode: 'hash',
  base: decodeURI('/'),
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/account",
    component: _c80b8086,
    name: "account"
  }, {
    path: "/c",
    component: _5efb539a,
    name: "c"
  }, {
    path: "/clusters",
    component: _3e6e757f,
    name: "clusters"
  }, {
    path: "/design-system",
    component: _1ff329ae,
    name: "design-system"
  }, {
    path: "/fail-whale",
    component: _6b9eb0bd,
    name: "fail-whale"
  }, {
    path: "/prefs",
    component: _8cee3606,
    name: "prefs"
  }, {
    path: "/auth/login",
    component: _3f259745,
    name: "auth-login"
  }, {
    path: "/auth/logout",
    component: _1ac34c44,
    name: "auth-logout"
  }, {
    path: "/auth/setup",
    component: _02803859,
    name: "auth-setup"
  }, {
    path: "/auth/verify",
    component: _5a748566,
    name: "auth-verify"
  }, {
    path: "/design-system/form-controls",
    component: _8c97b00a,
    name: "design-system-form-controls"
  }, {
    path: "/rio/mesh",
    component: _4d55ed47,
    name: "rio-mesh"
  }, {
    path: "/design-system/page-examples/create",
    component: _67a70f18,
    name: "design-system-page-examples-create"
  }, {
    path: "/design-system/page-examples/detail",
    component: _4f745826,
    name: "design-system-page-examples-detail"
  }, {
    path: "/design-system/page-examples/list",
    component: _d6bfe28c,
    name: "design-system-page-examples-list"
  }, {
    path: "/c/:cluster",
    component: _52fa306d,
    name: "c-cluster"
  }, {
    path: "/c/:cluster/apps",
    component: _320406ea,
    name: "c-cluster-apps"
  }, {
    path: "/c/:cluster/auth",
    component: _d8f3e2c0,
    name: "c-cluster-auth"
  }, {
    path: "/c/:cluster/backup",
    component: _49554afa,
    name: "c-cluster-backup"
  }, {
    path: "/c/:cluster/cis",
    component: _4aa43faa,
    name: "c-cluster-cis"
  }, {
    path: "/c/:cluster/ecm",
    component: _0c2ddc6d,
    name: "c-cluster-ecm"
  }, {
    path: "/c/:cluster/explorer",
    component: _886d7c12,
    name: "c-cluster-explorer"
  }, {
    path: "/c/:cluster/fleet",
    component: _3e0c5aac,
    name: "c-cluster-fleet"
  }, {
    path: "/c/:cluster/gatekeeper",
    component: _999d7716,
    name: "c-cluster-gatekeeper"
  }, {
    path: "/c/:cluster/istio",
    component: _aea8d3e4,
    name: "c-cluster-istio"
  }, {
    path: "/c/:cluster/logging",
    component: _11d8a2bd,
    name: "c-cluster-logging"
  }, {
    path: "/c/:cluster/longhorn",
    component: _4d8c5092,
    name: "c-cluster-longhorn"
  }, {
    path: "/c/:cluster/monitoring",
    component: _4a55f380,
    name: "c-cluster-monitoring"
  }, {
    path: "/c/:cluster/rio",
    component: _fe6f1294,
    name: "c-cluster-rio"
  }, {
    path: "/c/:cluster/virtual",
    component: _1351612e,
    name: "c-cluster-virtual"
  }, {
    path: "/console/:uid?/serial",
    component: _029d9a07,
    name: "console-uid-serial"
  }, {
    path: "/console/:uid?/vnc",
    component: _5f155428,
    name: "console-uid-vnc"
  }, {
    path: "/c/:cluster/apps/charts",
    component: _500f4fed,
    name: "c-cluster-apps-charts"
  }, {
    path: "/c/:cluster/apps/install",
    component: _2fc25733,
    name: "c-cluster-apps-install"
  }, {
    path: "/c/:cluster/auth/config",
    component: _c7486a32,
    name: "c-cluster-auth-config"
  }, {
    path: "/c/:cluster/explorer/HardwareResourceGauge",
    component: _5acf9708,
    name: "c-cluster-explorer-HardwareResourceGauge"
  }, {
    path: "/c/:cluster/gatekeeper/constraints",
    component: _7865a948,
    name: "c-cluster-gatekeeper-constraints"
  }, {
    path: "/c/:cluster/rio/dashboard",
    component: _35a28178,
    name: "c-cluster-rio-dashboard"
  }, {
    path: "/c/:cluster/rio/mesh",
    component: _c1b4078e,
    name: "c-cluster-rio-mesh"
  }, {
    path: "/c/:cluster/rio/tap",
    component: _27943ff2,
    name: "c-cluster-rio-tap"
  }, {
    path: "/c/:cluster/virtual/HardwareResourceGauge",
    component: _4548807a,
    name: "c-cluster-virtual-HardwareResourceGauge"
  }, {
    path: "/c/:cluster/virtual/Upgrade",
    component: _bbcd205a,
    name: "c-cluster-virtual-Upgrade"
  }, {
    path: "/c/:cluster/auth/config/:id",
    component: _e34549e2,
    name: "c-cluster-auth-config-id"
  }, {
    path: "/c/:cluster/:product",
    component: _c5a6f7b0,
    name: "c-cluster-product"
  }, {
    path: "/c/:cluster/:product/:resource",
    component: _523af6f4,
    name: "c-cluster-product-resource"
  }, {
    path: "/c/:cluster/:product/:resource/create",
    component: _2d2256f8,
    name: "c-cluster-product-resource-create"
  }, {
    path: "/c/:cluster/:product/:resource/:id",
    component: _37981f24,
    name: "c-cluster-product-resource-id"
  }, {
    path: "/c/:cluster/:product/:resource/:namespace/:id?",
    component: _8d3c34fa,
    name: "c-cluster-product-resource-namespace-id"
  }, {
    path: "/",
    component: _545eebc2,
    name: "index"
  }],

  fallback: false
}

export function createRouter () {
  return new Router(routerOptions)
}
